/* eslint-disable no-unused-vars */
import React, { createRef, FC, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { FormInstance } from 'antd/es/form/Form'
import { Select, Skeleton } from 'antd'
import {
    Button, Collapse, Form, Input, Space, List, Spin, notification, Table,
    Popover, Row, Col, Card, ConfigProvider, Radio, Image
} from 'antd'
import { CheckCircleOutlined, DownloadOutlined, StarOutlined, StarFilled, QuestionCircleOutlined } from '@ant-design/icons'
import zhCN from 'antd/es/locale/zh_CN'
import moment from 'moment'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import { IAppState } from '@/store/reducers'
import { getWorkgroup } from '@/store/actions/tableEdit.action'
import type { Descendant } from 'slate'
import { DefaultPlugin } from '@dslate/dslate'
import type { DSlateRef } from '@dslate/core'
import { downloadFile, getUuid, hideLoading, showLoading } from '@/utils/util'
import { handleTrim, serialize } from '@/pages/table2Mana/table2Edit'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import {
    getFile, getOnlineReviewById, getOnlineReviewTMT, addOnlineReviewTMT
} from '@/services/progress.service'
import { IAddOnlineReviewData, IFileRes } from '@/store/models/process.model'
import TechReviewImg from '@/assets/images/techReview.jpg'
import Nav from '@/components/nav'
import { ECoreTechnology, EJudgesType, ETechnologyContribution, ETechnologyLeadership } from '@/types'

const plugs = { ...DefaultPlugin }
// 删除图片工具
Reflect.deleteProperty(plugs, 'ImgPlugin')



const ReviewStart: FC = () => {
    const history = useHistory()
    const locationObj = useLocation()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const locationSearch = useRef<any>({})
    const formRef = createRef<FormInstance>()
    const formRef2 = createRef<FormInstance>()
    const [form] = Form.useForm()
    // 富文本编辑器
    // const editorRef = useRef<DSlateRef>(null)
    const editorRef2 = useRef<DSlateRef>(null)
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const userInfo = useSelector((state: IAppState) => state.auth.userInfo)
    const { Panel } = Collapse
    const { Option } = Select

    const [collapseValue, setCollapseValue] = useState<string[] | string>(['1', '2'])
    const [switchKey, setSwitchKey] = useState(['3', '4', '5', '6'])
    const [loaded, setLoaded] = useState(false)
    const [loading, setLoading] = useState(false)
    // 查看信息
    const [formObj, setFormObj] = useState<IAddOnlineReviewData & {
        id: number,
        creator: string,
        files: IFileRes[]
        parentTech?: string
        productFunction?: string
        techScope?: string
        techPerformance?: string
        techSource?: string
        firstUseDate?: string
        reviewContent?: string
        isPL?: number
        isPlReview?: boolean
        techLeaders?: string
        coreMembers?: string
        generalMembers?: string
    } | null>(null)
    // 回显反馈
    const [formObjFeed, setFormObjFeed] = useState<any>(null)
    // 已反馈用户列表
    const [, setFeedbackList] = useState<any[]>([])
    // 是否已反馈过
    const [feeded, setFeeded] = useState(false)
    // 记录是否参与
    const [isParticipate, setIsParticipate] = useState<boolean | null>(null)
    const [isPassed, setIsPassed] = useState<boolean | null>(null)
    // 已反馈用户列表
    const [need, setNeed] = useState(-1)
    const [maturity, setMaturity] = useState(-1)
    const [diffrentiation, setDiffrentiation] = useState(-1)
    const [costSaving, setCostSaving] = useState(-1)
    const [feedbackTMTList, setFeedbackTMTList] = useState<any>(null)
    // 是否评审或旁听
    const [judgesType, setJudgesType] = useState<any>(EJudgesType.NULL)
    console.log(judgesType, 'judgesType')
    // 评审类型
    const [approvalTypeValue, setApprovalTypeValue] = useState<number>(-1)
    // 富文本编辑器 内容
    // 提案申请相关性反馈
    // const [descriptionValue, setDescriptionValue] = useState<Descendant[]>([
    //     {
    //         type: 'paragraph',
    //         children: [{ text: '' }],
    //     },
    // ])
    // 评审内容
    const [descriptionValue2, setDescriptionValue2] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])
    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 15 },
    }
    const tailLayout = {
        wrapperCol: { offset: 6, span: 15 },
    }
    const approvalType = [
        { id: 1, label: t('technicalPlan') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 2, label: t('technicalDefineAndResearchTaskBook') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 3, label: t('technicalAchievementDelivery') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 4, label: t('techIssues') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
    ]

    const findLabel = (arr: any[], id: number) =>
        arr.find(((item: any) => item.id === id))?.label ?? ''

    const technologicalLeadershipArr = useRef([{
        label: t('leadership'),
        id: ETechnologyLeadership.LEADING
    },
    // {
    //     label: t('homeleadership'),
    //     id: ETechnologyLeadership.HOME_LEADING
    // },
    {
        label: t('equalize'),
        id: ETechnologyLeadership.EQUAL
    }, {
        label: t('trail'),
        id: ETechnologyLeadership.TRAIL
    }])
    const technicalContributionArr = useRef([{
        label: t('innovationSellingPoint'),
        id: ETechnologyContribution.INNOVATION
    }, {
        label: t('keySellingPoint'),
        id: ETechnologyContribution.KEY
    }, {
        label: t('secondarySellingPoints'),
        id: ETechnologyContribution.SECONDARY
    }, {
        label: t('basicTechnology'),
        id: ETechnologyContribution.BASIC
    }])

    const labelArr = [t('core') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
        t('key') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
        t('basicTechnology'),
        t('reserveTechnology'),
    ]

    // const isPLReview = useMemo(() => {
    //     if (feedbackTMTList && feedbackTMTList.length > 0) {
    //         const isFind = feedbackTMTList.some((item: any) =>
    //             item?.isPL !== 0 && !!item.technologyLeadership
    //         )
    //         console.log('isPLReview isFind: ', isFind, formObj)
    //         return isFind && formObj?.reviewType !== 3 && formObj?.reviewType !== 2
    //     }
    //     return false
    // }, [feedbackTMTList, formObj])
    // 判断PL TMT用户是否全部评审完成
    const isPLTMTReviewCompleted = useMemo(() => {
        if (!feedbackTMTList) return false
        const plUsers = feedbackTMTList.filter((user: any) => user.isPL === 1)
        if (plUsers.length === 0) return true // 如果没有PL用户，认为PL阶段已完成
        return plUsers.every((user: any) => user.reviewContent && user.reviewContent.trim() !== '')
    }, [feedbackTMTList])

    // 获取当前评审阶段
    const getCurrentReviewPhase = useMemo(() => {
        if (!feedbackTMTList || (!formObj?.isPlReview && formObj?.reviewType !== 4)) return null

        if (!isPLTMTReviewCompleted) {
            // 如果 PL TMT 评审未完成，保持在 PL TMT 评审阶段
            return 'pltmt'
        }

        // PL TMT 评审已完成，
        const dueDate = moment(formObj?.dueDate)
        const fiveDaysAfterDue = dueDate
        const now = moment()
        const isFiveDaysPassed = now.isAfter(fiveDaysAfterDue)
        if (isFiveDaysPassed) {
            // 如果 PL TMT 评审完成且已过 5 天，进入 TMT 评审阶段
            return 'tmt'
        } else {
            // 如果 PL TMT 评审完成但未过 5 天，等待期间保持在 PL TMT 阶段
            return 'pltmt'
        }
    }, [feedbackTMTList, formObj?.isPlReview, formObj?.reviewType, formObj?.dueDate, isPLTMTReviewCompleted])

    // 是否是PL 角色
    const isPlRole = useMemo(() => {
        if (feedbackTMTList && feedbackTMTList.length > 0) {
            const isFind = feedbackTMTList.some((item: any) =>
                item.tmtUser === userInfo?.login && item.isPL === 1
            )
            console.log(isFind, 'isFind')
            return isFind && getCurrentReviewPhase === 'pltmt'
        }
        return false
    }, [feedbackTMTList, getCurrentReviewPhase, userInfo])
    // 是否是PL TMT 提案
    const isPLTMTProposal = useMemo(() => {
        if (formObj?.reviewType === 4) {
            return true
        }
        return false
    }, [formObj?.reviewType])

    const isPassedFormValue = Form.useWatch('isPassed', form)

    const [, setColumns] = useState([
        {
            title: () => <span>{t('feedbackName')}</span>,
            dataIndex: 'creatorName',
            key: 'creatorName',
            width: 150,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('WorkGroup')}</span>,
            dataIndex: 'workGroup',
            key: 'workGroup',
            width: 150,
            ellipsis: { showTitle: true },
            render(value: any) {
                return value?.workGroupName || ''
            }
        },
        {
            title: () => <span>{t('isRelevant')}</span>,
            dataIndex: 'isRelevant',
            key: 'isRelevant',
            width: 100,
            ellipsis: { showTitle: true },
            // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
            render(value: boolean, record: any) {
                if (record.auditOrNot) {
                    return <span>{t('sitInOn')}</span>
                } else {
                    if (value !== null) {
                        if (value) {
                            return <span>{t('Yes')}</span>
                        }
                        return <span>{t('No')}</span>
                    } else {
                        return <></>
                    }
                }
            }
        },
        {
            title: () => <span>{t('tmtUser')}</span>,
            dataIndex: 'tmtInfos',
            key: 'tmtInfos',
            width: 150,
            ellipsis: { showTitle: true },
            render(value: any[]) {
                return value.map(item => item.tmtFullUser).join(', ')
            }
        },
        {
            title: () => <span>{t('description')}</span>,
            dataIndex: 'description',
            key: 'description',
            width: 150,
            ellipsis: { showTitle: true },
            render(value: string) {
                return <Popover
                    placement="topLeft"
                    title=""
                    content={
                        <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                            dangerouslySetInnerHTML={{
                                __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                            }}
                        ></div>
                    }
                >
                    <div style={{ maxWidth: 240 }}
                        className='table_ellipsis'
                        dangerouslySetInnerHTML={{
                            __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                        }}
                    ></div>
                </Popover>
            }
        },
    ])
    const tmtColumns = [
        {
            title: () => <span>{t('feedbackName')}</span>,
            dataIndex: 'tmtFullUser',
            key: 'tmtFullUser',
            width: 120,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('feedbackName') + (i18n.language !== 'zh' ? ' ' : '') + t('type')}</span>,
            dataIndex: 'isPL',
            key: 'isPL',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: number) {
                // 增加除了PL TMT之外的都是TMT
                return ((value === 1 || value === 2) ? <span>PL TMT</span> : <span>TMT</span>)
            }
        },
        {
            title: () => <span>{t('WorkGroup')}</span>,
            dataIndex: 'workGroup',
            key: 'workGroup',
            width: 150,
            ellipsis: { showTitle: true },
            render(value: any) {
                return value?.workGroupName || ''
            }
        },
        {
            title: () => <span>{t('technologicalLeadership')}</span>,
            dataIndex: 'technologyLeadership',
            key: 'technologyLeadership',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: number) {
                // if (!value && formObj) {
                //     if (record.tmtFullUser === formObj.creator) {
                //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //         // @ts-ignore
                //         return findLabel(technologicalLeadershipArr.current, formObj.technologyLeadership)
                //     }
                // }
                return findLabel(technologicalLeadershipArr.current, value)
            }
        },
        {
            title: () => <span>{t('technicalContribution')}</span>,
            dataIndex: 'technologyContribution',
            key: 'technologyContribution',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: number) {
                // if (!value && formObj) {
                //     if (record.tmtFullUser === formObj.creator) {
                //         console.log('formObj: ', formObj)
                //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //         // @ts-ignore
                //         return findLabel(technicalContributionArr.current, formObj.technologyContribution)
                //     }
                // }
                return findLabel(technicalContributionArr.current, value)
            }
        },
        {
            title: () => <span>{t('techType')}</span>,
            dataIndex: 'coreTechnology',
            key: 'coreTechnology',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: number) {
                // if (!value && formObj) {
                //     if (record.tmtFullUser === formObj.creator) {
                //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //         // @ts-ignore
                //         return labelArr[formObj.coreTechnology]
                //     }
                // }
                return labelArr[value]
            }
        },
        {
            title: () => <span>{t('isParticipate')}</span>,
            dataIndex: 'isParticipate',
            key: 'isParticipate',
            width: 150,
            ellipsis: { showTitle: true },
            render(value: boolean | null, record: any) {
                // 参加评审
                if (record.judgesType === EJudgesType.REVIEWER) {
                    if (value == null) {
                        // 未参会，弃权
                        // 二次提案则为空
                        return !record.parent ? <span>{t('notAddAbstention')}</span> : <></>
                    }
                    return <span>{t('join')}</span>
                } else {
                    // 旁听
                    return <span>{t('sitInOn')}</span>
                }
            }
        },
        {
            title: () => <span>{t('reviewResultTrue')}</span>,
            dataIndex: 'isPassed',
            key: 'isPassed',
            width: 80,
            ellipsis: { showTitle: true },
            render(value: boolean | null, record: any) {
                if (record.judgesType === EJudgesType.REVIEWER && record.isParticipate === false) {
                    return <span>{t('EO1uGpLLmtFgYZU5vBc7Q')}</span>
                }
                if (value !== null) {
                    if (value) {
                        return <span>{t('Yes')}</span>
                    } else {
                        return <span>{t('No')}</span>
                    }
                } else {
                    return <></>
                }
            }
        },
        // {
        //     title: () => <span>{t('tmtMail')}</span>,
        //     dataIndex: 'tmtMail',
        //     key: 'tmtMail',
        //     width: 150,
        //     ellipsis: { showTitle: true }
        // },
        {
            title: () => <span>{t('reviewMeeting') + (i18n.language !== 'zh' ? ' ' : '') + t('date')}</span>,
            dataIndex: 'modifyTime',
            key: 'modifyTime',
            width: 100,
            ellipsis: { showTitle: true },
            render(value: number | null) {
                return value ? moment(value).format('YYYY-MM-DD') : ''
            }
        },
        {
            title: () => <span>{t('reviewContent')}</span>,
            dataIndex: 'reviewContent',
            key: 'reviewContent',
            ellipsis: { showTitle: true },
            render(value: string) {
                return <Popover
                    placement="topLeft"
                    title=""
                    content={
                        <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                            dangerouslySetInnerHTML={{
                                __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                            }}
                        ></div>
                    }
                >
                    <div style={{ maxWidth: 240 }}
                        className='table_ellipsis'
                        dangerouslySetInnerHTML={{
                            __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                        }}
                    ></div>
                </Popover>
            }
        },
    ]

    // 提案申请相关性反馈
    const onFinish = async (values: any) => {
        let desc = ''
        if (formObj?.reviewType === 1) {
            const editorHtmlValue = editorRef2.current?.serialize({ children: serialize(handleTrim(descriptionValue2)) })
            desc = JSON.stringify({
                str: editorHtmlValue || '',
                obj: handleTrim(descriptionValue2)
            })
        }
        let isParticipate = null
        if (values?.isParticipate) {
            isParticipate = values.isParticipate === 1 ? true : null
        } else {
            isParticipate = formObjFeed?.isParticipate
        }
        const formData = {
            ...values,
            need: values.need || 0,
            maturity: values.maturity || 0,
            diffrentiation: values.diffrentiation || 0,
            costSaving: values.costSaving || 0,
            isCross: values.isCross === 1 ? true : (values.isCross === 2 ? false : null),
            // 是否同意技术规划: 通过 true; 不通过 false; 弃权 undefined
            isPassed: values.isPassed === 1 ? true : (values.isPassed === 2 ? false : undefined),
            // 是否参与评审: 如果选择弃权，设为 false，如果不是选择弃权，则原来是啥就传啥
            isParticipate: values.isPassed !== 3 ? isParticipate : false,
            judgesType,
        }
        if (isPLTMTProposal) {
            if (isPlRole) {
                formData.technologyContribution = values.technologyContribution
                // 删除技术贡献
                delete formData.technologyLeadership
            } else {
                formData.technologyLeadership = values.technologyLeadership
                // 删除技术贡献
                delete formData.technologyContribution
            }
        }

        console.log('onFinish: ', values, formData, desc)
        // todo 测试
        // const flag = true
        // if(flag){
        //     return
        // }
        try {
            setLoading(true)
            // 保存评分
            await addOnlineReviewTMT({
                ...formData,
            }).finally(() => {
                setLoading(false)
            })
            const args = {
                message: t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('success'),
                description: '',
                icon: <CheckCircleOutlined style={{ color: '#08993f' }} />,
                duration: 3,
            }
            notification.open(args)
            if (locationObj.key) {
                history.goBack()
            } else {
                history.replace('/techReviewProgress')
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any }) => {
        console.log('onFinishFailed: ', errorFields)
    }
    const onSelectStar = (str: string, num: number) => {
        switch (str) {
            case 'need':
                setNeed(num)
                break
            case 'maturity':
                setMaturity(num)
                break
            case 'diffrentiation':
                setDiffrentiation(num)
                break
            case 'costSaving':
                setCostSaving(num)
                break
            default:
        }
        formRef.current?.setFieldValue(str, num + 1)
    }
    const onChangeCollapse = (e: string[] | string) => {
        setCollapseValue(e)
    }

    const onChangeSelect = (e: any, str: string) => {
        console.log('onChangeSelect: ', e, str)
        const technologyLeadership = formRef.current?.getFieldValue('technologyLeadership')
        const technologyContribution = formRef.current?.getFieldValue('technologyContribution')

        if (!technologyLeadership || !technologyContribution) {
            formRef.current?.setFieldValue('coreTechnology', ECoreTechnology.INVALID)
        }

        if (technologyLeadership <= ETechnologyLeadership.EQUAL || technologyLeadership === ETechnologyLeadership.HOME_LEADING) {
            if (technologyContribution <= ETechnologyContribution.KEY) {
                formRef.current?.setFieldValue('coreTechnology', ECoreTechnology.CORE)
            } else {
                formRef.current?.setFieldValue('coreTechnology', ECoreTechnology.RESERVE)
            }
        } else {
            if (technologyContribution <= ETechnologyContribution.KEY) {
                formRef.current?.setFieldValue('coreTechnology', ECoreTechnology.KEY)
            } else {
                formRef.current?.setFieldValue('coreTechnology', ECoreTechnology.BASIC)
            }
        }
    }

    // 查看提案申请信息
    const getViewDetail = async (id: string) => {
        try {
            showLoading(<Spin size='large' />)
            const res = await getOnlineReviewById(+id).finally(() => {
                hideLoading()
            })
            console.log('getViewDetail: ', res)
            setLoaded(true)
            if (!res.description.includes('"obj":')) {
                res.description = JSON.stringify([
                    {
                        type: 'paragraph',
                        children: [{ text: res.description }]
                    }]
                )
            }
            if (approvalTypeValue === -1 && res.reviewType) {
                setApprovalTypeValue(res.reviewType - 1)
            }

            setFormObj({
                id: res.id,
                version: res.version,
                fileIds: res.files.map(item => item.id),
                workGroupId: res.workGroup.id,
                roadMap: res.roadMap,
                proposalName: res.proposalName,
                subsidiary: res.subsidiary,
                reviewType: res.reviewType,
                reviewDate: moment(res.reviewDate),
                reviewDateHours: res.reviewDateHours,
                dueDate: moment(res.dueDate).format('YYYY-MM-DD'),
                isDisruptive: res.isDisruptive,
                disruptiveReview: res.disruptiveReview,
                isCross: res.isCross,
                isCrossReview: res.isCrossReview,
                techLevel: res.techLevel,
                description: res.description,
                creator: res.creator || '',
                files: res.files,
                costBuss: res.costBuss ? res.costBuss.map((item: any) => item.bu) : [],
                dutyBuss: res.dutyBuss ? res.dutyBuss.map((item: any) => item.bu) : [],
                openRelevant: res.openRelevant,
                parentTech: res.parentTech,
                productFunction: res.productFunction,
                technologyContribution: res.technologyContribution,
                technologyLeadership: res.technologyLeadership,
                coreTechnology: res.coreTechnology,
                techScope: res.techScope,
                techPerformance: res.techPerformance,
                techSource: isNaN(Number(res.techSource)) ? res.techSource :
                    [t('independentIP'), t('outsourcedTechnology'), t('coDevelopedTechnology')][
                        Number(res.techSource) - 1
                    ],
                firstUseDate: res.firstUseDate,
                techLeaders: res.techLeaders,
                coreMembers: res.coreMembers,
                generalMembers: res.generalMembers,
                isPlReview: res.isPlReview
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const getFeedbackTMTLs = async (id: string) => {
        try {
            const res = await getOnlineReviewTMT(+id)

            // TMT 评审记录
            setFeedbackTMTList(res || [])

            getViewDetail(id)

            setFeedbackList(res)
            console.log('tmt反馈列表: ', res)
            // 找出自己填的记录，并回显
            if (userInfo) {
                // isParticipate !== null 已反馈过
                // const findObj = res.find(item => item.isParticipate !== null && item.tmtUser === userInfo.login)
                const findObj = res.find(item => item.tmtUser === userInfo.login)
                console.log('findObj: ', findObj)
                const findPLTmt = res.find(item => item.isPL === 1 || item.isPL === 2)
                if (findObj) {
                    // 设为已反馈(findObj.isParticipate === false 表示已参会，弃权)
                    if (findObj.isPassed != null || findObj.isParticipate === false) {
                        setFeeded(true)
                    }
                    setJudgesType(findObj.judgesType)
                    if (findObj.reviewContent) {
                        if (findObj.reviewContent.includes('"obj":')) {
                            const descriptionObj = JSON.parse(findObj.reviewContent)
                            setDescriptionValue2(descriptionObj.obj)
                        } else {
                            setDescriptionValue2([
                                {
                                    type: 'paragraph',
                                    children: [{ text: findObj.reviewContent }],
                                }
                            ])
                        }
                    }
                    // isParticipate === false 表示已参会，弃权
                    const _isParticipate = findObj.isParticipate !== null ? (findObj.isParticipate ? 1 : 2) : findObj.isParticipate
                    const _techOnlineReviewId = locationSearch.current.progressId
                    const obj = {
                        ...findObj,
                        isCross: findObj.isCross === true ? 1 : (findObj.isCross === false ? 2 : null),
                        // isParticipate === false 表示已参会，弃权
                        isPassed: findObj.isParticipate === false ? 3
                            : (findObj.isPassed === true ? 1 : (findObj.isPassed === false ? 2 : null)),
                        techOnlineReviewId: _techOnlineReviewId,
                        isParticipate: _isParticipate,
                        findPLTmt // PL TMT评审后，TMT 评审需要显示出来，并且不能修改
                    }
                    // formRef.current 始终为空，需要要useEffect [formObjFeed] 中去做处理
                    // formRef.current?.setFieldsValue(obj)
                    obj.need && onSelectStar('need', obj.need)
                    obj.maturity && onSelectStar('maturity', obj.maturity)
                    obj.diffrentiation && onSelectStar('diffrentiation', obj.diffrentiation)
                    obj.costSaving && onSelectStar('costSaving', obj.costSaving)
                    setFormObjFeed(obj)
                    setIsParticipate(findObj.isParticipate)
                    setIsPassed(findObj.isPassed)
                    setSwitchKey([switchKey[0], getUuid(8), getUuid(8), switchKey[3]])
                }
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/techReviewProgress',
            breadcrumbName: t('technicalReviewProcess'),
        },
        {
            path: '/addProgress',
            breadcrumbName: 'ITMT' + (i18n.language !== 'zh' ? ' ' : '') + t('feedback'),
        },
    ])
    useEffect(() => {
        console.log('locationObj: ', locationObj)
        const routeParams = new URLSearchParams(location.search)
        const progressIdParam = routeParams.get('progressId')
        const isWriteParam = routeParams.get('write')
        const type = routeParams.get('type')
        if (type) {
            setApprovalTypeValue(Number(type) - 1)
        }
        locationSearch.current = {
            progressId: +(progressIdParam || ''),
            isWrite: isWriteParam ? true : undefined
        }
        if (type) {
            localStorage.setItem('curTab', type)
        }
        routes[1] = {
            path: '/techReviewProgress',
            breadcrumbName: approvalType[(Number(type) || 1) - 1].label
        }
        if (progressIdParam) {
            if (isWriteParam === 'true') {
                // getFeedbackLs(progressIdParam)
                // 获取反馈信息
                getFeedbackTMTLs(progressIdParam)
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                setColumns(tmtColumns)
                const curRoute = {
                    path: '/addProgress',
                    breadcrumbName: 'TMT' + (i18n.language !== 'zh' ? ' ' : '') + t('writeFeedback'),
                }
                routes.splice(routes.length - 1, 1, curRoute)
            }
            formRef.current?.setFieldValue('techOnlineReviewId', +progressIdParam)
        }
        setRoutes([...routes])
        if (!workgroupList.length) {
            // 获取 workgroupList
            dispatch(getWorkgroup())
        }
    }, [])
    // 详情
    useEffect(() => {
        if (formObj) {
            console.log('formRef2: ', formRef2, formObj)
            formRef2.current?.setFieldsValue(formObj)
        }
    }, [formObj])
    // 回显反馈
    useEffect(() => {
        console.log('formRef: ', formRef, formObjFeed)
        if (formObjFeed && formRef.current) {
            formRef.current?.setFieldsValue({
                ...formObjFeed,
                reviewContent: '',
                technologyContribution: formObjFeed.findPLTmt?.technologyContribution,
                technologyLeadership: formObjFeed.findPLTmt?.technologyLeadership,
                coreTechnology: formObjFeed.findPLTmt?.coreTechnology,
            })
        }
    }, [formObjFeed])

    const isSecondReview = useMemo(() => {
        return  !formObj?.parent?.id
    }, [formObj])

    // useEffect(() => {
    // 不设置值验证会报错
    // formRef.current?.setFieldValue('reviewContent', 111)
    // formRef.current?.validateFields(['reviewContent'])
    // }, [descriptionValue2])
    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                dispatch={dispatch}
            />
            <Collapse collapsible="header" className="edit_table"
                style={{ paddingTop: 0 }}
                activeKey={collapseValue}
                onChange={onChangeCollapse}
            >
                <Panel
                    header={(!locationSearch.current.isWrite ? t('feedback') : t('writeFeedback'))}
                    key="1"
                    forceRender
                    collapsible='disabled'
                >
                    <Row>
                        <Col span={13}>
                            <Form {...layout} ref={formRef}
                                onFinish={onFinish}
                                form={form}
                                onFinishFailed={onFinishFailed}
                            >
                                <Form.Item name="techOnlineReviewId" hidden><Input /></Form.Item>
                                {formObj?.reviewType === 1 || isSecondReview ? <>
                                    {loaded && judgesType === EJudgesType.NULL && <Form.Item {...tailLayout} style={{ color: '#f00' }}>
                                        {t('noFeedAuth')}
                                    </Form.Item>}
                                    {formObj?.openRelevant === null && loaded && judgesType === EJudgesType.REVIEWER && locationSearch.current.isWrite && (
                                        <>
                                            {/* 是否参与评审 */}
                                            <Form.Item name='isParticipate'
                                                label={<span className='label'>{t('isParticipate')}</span>}
                                                rules={[
                                                    {
                                                        required: true, message: t('isParticipate Required')
                                                    },
                                                ]}
                                            >
                                                <Radio.Group key={switchKey[2]} disabled={(isParticipate === true && isPassed === false)}>
                                                    <Radio value={1}>{t('Yes')}</Radio>
                                                    <Radio value={2}>{t('No')}</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </>
                                    )}
                                    {formObj?.openRelevant !== null && loaded && locationSearch.current.isWrite && (
                                        // TMT 成员填写反馈
                                        <>
                                            {judgesType === EJudgesType.REVIEWER && (<>
                                                {formObj?.isDisruptive &&
                                                    (<>
                                                        {/* Disruptive 评分 */}
                                                        <Form.Item
                                                            label={<span className='label'>{t('disruptiveScore')}</span>}
                                                        >
                                                            {t('disruptive_remark')}
                                                        </Form.Item>
                                                        {/* 需求重要性 */}
                                                        <Form.Item name='need'
                                                            label={<span className='label'>{t('need')}</span>}
                                                            tooltip={{ title: (t('disruptive_Need')), color: 'red' }}
                                                            rules={[{ required: true, message: t('Please Select') + t('need') }]}
                                                        >
                                                            <Input hidden />
                                                            {
                                                                Array(10).fill(1).map((_, index) => {
                                                                    if (index <= need) {
                                                                        return (<StarFilled style={{ fontSize: 18, color: '#efdd09', marginLeft: 5 }}
                                                                            className='star'
                                                                            key={index}
                                                                            onClick={() => {
                                                                                onSelectStar('need', index)
                                                                            }
                                                                            }
                                                                        />)
                                                                    } else {
                                                                        return (<StarOutlined style={{ fontSize: 18, marginLeft: 5 }}
                                                                            className='star'
                                                                            key={index}
                                                                            onClick={() => {
                                                                                onSelectStar('need', index)
                                                                            }
                                                                            }
                                                                        />)
                                                                    }
                                                                })
                                                            }
                                                        </Form.Item>
                                                        {/* 技术成熟度 */}
                                                        <Form.Item name='maturity'
                                                            label={<span className='label'>{t('maturityStar')}</span>}
                                                            tooltip={{ title: (t('disruptive_maturity')), color: 'red' }}
                                                            rules={[{ required: true, message: t('Please Select') + t('maturityStar') }]}
                                                        >
                                                            <Input hidden />
                                                            {
                                                                Array(10).fill(1).map((_, index) => {
                                                                    if (index <= maturity) {
                                                                        return (<StarFilled style={{ fontSize: 18, color: '#efdd09', marginLeft: 5 }}
                                                                            className='star'
                                                                            key={index}
                                                                            onClick={() => {
                                                                                onSelectStar('maturity', index)
                                                                            }
                                                                            }
                                                                        />)
                                                                    } else {
                                                                        return (<StarOutlined style={{ fontSize: 18, marginLeft: 5 }}
                                                                            className='star'
                                                                            key={index}
                                                                            onClick={() => {
                                                                                onSelectStar('maturity', index)
                                                                            }
                                                                            }
                                                                        />)
                                                                    }
                                                                })
                                                            }
                                                        </Form.Item>
                                                        {/* 行业区别度 */}
                                                        <Form.Item name='diffrentiation'
                                                            label={<span className='label'>{t('diffrentiation')}</span>}
                                                            tooltip={{ title: (t('disruptive_diffrentiation')), color: 'red' }}
                                                            rules={[{ required: true, message: t('Please Select') + t('diffrentiation') }]}
                                                        >
                                                            <Input hidden />
                                                            {
                                                                Array(10).fill(1).map((_, index) => {
                                                                    if (index <= diffrentiation) {
                                                                        return (<StarFilled style={{ fontSize: 18, color: '#efdd09', marginLeft: 5 }}
                                                                            className='star'
                                                                            key={index}
                                                                            onClick={() => {
                                                                                onSelectStar('diffrentiation', index)
                                                                            }
                                                                            }
                                                                        />)
                                                                    } else {
                                                                        return (<StarOutlined style={{ fontSize: 18, marginLeft: 5 }}
                                                                            className='star'
                                                                            key={index}
                                                                            onClick={() => {
                                                                                onSelectStar('diffrentiation', index)
                                                                            }
                                                                            }
                                                                        />)
                                                                    }
                                                                })
                                                            }
                                                        </Form.Item>
                                                        {/* 潜在成本优势 */}
                                                        <Form.Item name='costSaving'
                                                            label={<span className='label'>{t('costSaving')}</span>}
                                                            tooltip={{ title: (t('disruptive_costSaving')), color: 'red' }}
                                                            rules={[{ required: true, message: t('Please Select') + t('costSaving') }]}
                                                        >
                                                            <Input hidden />
                                                            {
                                                                Array(10).fill(1).map((_, index) => {
                                                                    if (index <= costSaving) {
                                                                        return (<StarFilled style={{ fontSize: 18, color: '#efdd09', marginLeft: 5 }}
                                                                            className='star'
                                                                            key={index}
                                                                            onClick={() => {
                                                                                onSelectStar('costSaving', index)
                                                                            }
                                                                            }
                                                                        />)
                                                                    } else {
                                                                        return (<StarOutlined style={{ fontSize: 18, marginLeft: 5 }}
                                                                            className='star'
                                                                            key={index}
                                                                            onClick={() => {
                                                                                onSelectStar('costSaving', index)
                                                                            }
                                                                            }
                                                                        />)
                                                                    }
                                                                })
                                                            }
                                                        </Form.Item>
                                                    </>)}
                                                {formObj?.isCross && <>
                                                    {/* Crossbreed认定结论 */}
                                                    <Form.Item name='isCross'
                                                        label={<span className='label'>{t('CrossbreedResult')}</span>}
                                                        rules={[
                                                            {
                                                                required: true, message: t('isCrossResult') + t('required')
                                                            }
                                                        ]}
                                                    >
                                                        <Radio.Group key={switchKey[1]}>
                                                            <Radio value={1}>{t('Yes')}</Radio>
                                                            <Radio value={2}>{t('No')}</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </>}
                                            </>)}
                                            {/* 注册或旁听 处理意见 */}
                                            <Form.Item name='reviewContent'
                                                label={<span className='label'>{
                                                    (judgesType !== EJudgesType.AUDITOR
                                                        ? ((judgesType === EJudgesType.REVIEWER ? t('approval') : t('sitInOn'))
                                                            + (i18n.language !== 'zh' ? ' ' : ''))
                                                        : ''
                                                    ) + t('reviewContent')
                                                }</span>}
                                                rules={[
                                                    {
                                                        required: true,
                                                        validator: async (_, value) => {
                                                            if (!value || value.trim().length === 0) {
                                                                return Promise.reject(t('reviewContent Required'))
                                                            }
                                                            if (value.trim().length < 10) {
                                                                return Promise.reject(`${t('minLenError')} 10 ${t('lenCharError')}`)
                                                            }
                                                            return Promise.resolve()
                                                        }
                                                    },
                                                ]}
                                            >
                                                {!feeded ? (
                                                    <Input.TextArea
                                                        autoSize={{ minRows: 4 }}
                                                    />
                                                ) : (
                                                    <div dangerouslySetInnerHTML={{
                                                        __html: formObjFeed?.reviewContent ? ((formObjFeed?.reviewContent.includes('"str":') || formObjFeed?.reviewContent.includes('"obj":')) ? JSON.parse(formObjFeed?.reviewContent)?.str : formObjFeed?.reviewContent) : ''
                                                    }} style={{ wordBreak: 'break-word' }}></div>
                                                )}
                                            </Form.Item>
                                            {judgesType === EJudgesType.REVIEWER && (<>
                                                <Form.Item name='isPassed'
                                                    label={<span className='label'>{t('isNot')
                                                        + (i18n.language !== 'zh' ? ' ' : '') + t('approve')
                                                        + (i18n.language !== 'zh' ? ' ' : '')
                                                        + (approvalType[approvalTypeValue]?.label ?? '')}</span>}
                                                    rules={[
                                                        {
                                                            required: true, message: t('isPassed Required')
                                                        },
                                                    ]}
                                                >
                                                    <Radio.Group key={switchKey[2]}>
                                                        <Radio value={1}>{t('Yes')}</Radio>
                                                        <Radio value={2}>{t('No')}</Radio>
                                                        {/* 主域以外的评委增加一个【弃权】选项 ( Leader 同时是 PRG 或 TSP 则无 workGroup ) */}
                                                        {formObjFeed?.workGroup?.id && formObj?.workGroupId !== formObjFeed?.workGroup?.id
                                                            && <Radio value={3}>{t('waiver')}</Radio>
                                                        }
                                                    </Radio.Group>
                                                </Form.Item>
                                            </>)}
                                        </>
                                    )}
                                </> : <>
                                    {/* BU TMT批准技术课题评审 */}
                                    {judgesType === EJudgesType.REVIEWER && (<>
                                        <Form.Item name='isPassed'
                                            label={<span className='label'>{t('isNot')
                                                + (i18n.language !== 'zh' ? ' ' : '') + t('approve')
                                                + (i18n.language !== 'zh' ? ' ' : '')
                                                + (approvalType[approvalTypeValue]?.label ?? '')}</span>
                                            }
                                            rules={[
                                                {
                                                    required: true, message: t('isPassed Required')
                                                },
                                            ]}
                                        >
                                            <Radio.Group key={switchKey[2]}>
                                                <Radio value={1}>{t('Yes')}</Radio>
                                                <Radio value={2}>{t('No')}</Radio>
                                                {/* 主域以外的评委增加一个【弃权】选项 ( Leader 同时是 PRG 或 TSP 则无 workGroup ) */}
                                                {formObjFeed?.workGroup?.id && formObj?.workGroupId !== formObjFeed?.workGroup?.id
                                                    && <Radio value={3}>{t('waiver')}</Radio>
                                                }
                                            </Radio.Group>
                                        </Form.Item>
                                    </>)}
                                    {
                                        isPassedFormValue === 1 && (
                                            <>
                                                <Form.Item label=' ' colon={false}>
                                                    <Image src={TechReviewImg} />
                                                </Form.Item>
                                                <Form.Item
                                                    name='technologyLeadership'
                                                    label={<span className='label'>
                                                        {t('technologicalLeadership')}
                                                        <Popover
                                                            placement="topLeft"
                                                            title=""
                                                            content={
                                                                <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', lineHeight: 1.5 }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: `<h4><b>${t('prompt1')}</b></h4><p>${t('prompt2')}</p>` +
                                                                            `<p>${t('prompt3')}</p>`
                                                                    }}
                                                                ></div>
                                                            }
                                                        >
                                                            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                        </Popover>
                                                    </span>}
                                                    rules={[{
                                                        required: !isPlRole || !isPLTMTProposal,
                                                        message: t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('technologicalLeadership')
                                                    }]}

                                                >
                                                    {/* <Select disabled={isPLReview} */}
                                                    <Select
                                                        disabled={isPlRole && isPLTMTProposal}
                                                        allowClear placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('technologicalLeadership')}
                                                        onChange={(e) => onChangeSelect(e, 'leadership')}
                                                    >
                                                        {
                                                            technologicalLeadershipArr.current.map(item => {
                                                                return <Option key={item.id} value={item.id}>{item.label}</Option>
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item
                                                    name='technologyContribution'
                                                    label={<span className='label'>
                                                        {t('technicalContribution')}
                                                        <Popover
                                                            placement="topLeft"
                                                            title=""
                                                            content={
                                                                <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', lineHeight: 1.5 }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: `<h4><b>${t('prompt4')}</b></h4>` +
                                                                            `<p>${t('prompt5')}</p><p>${t('prompt6')}</p>` +
                                                                            `<h4 style='margin-top: 10px;'><b>${t('prompt7')}</b></h3>` +
                                                                            `<p>${t('prompt8')}</p>`
                                                                    }}
                                                                ></div>
                                                            }
                                                        >
                                                            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                        </Popover>
                                                    </span>}
                                                    rules={[{
                                                        required: isPlRole || !isPLTMTProposal,
                                                        message: t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('technicalContribution')
                                                    }]}
                                                >
                                                    {/* <Select disabled={isPLReview} */}
                                                    <Select
                                                        disabled={!isPlRole && isPLTMTProposal}
                                                        allowClear placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('technicalContribution')}
                                                        onChange={(e) => onChangeSelect(e, 'contribution')}
                                                    >
                                                        {
                                                            technicalContributionArr.current.map(item => {
                                                                return <Option key={item.id} value={item.id}>{item.label}</Option>
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item
                                                    shouldUpdate
                                                    noStyle
                                                >
                                                    {({ getFieldValue }) => {
                                                        const value = getFieldValue('coreTechnology')
                                                        return <Form.Item
                                                            name='coreTechnology'
                                                            label={t('techType')}
                                                        >
                                                            {
                                                                [t('core') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
                                                                    t('key') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
                                                                    t('basicTechnology'),
                                                                    t('reserveTechnology'),
                                                                ][value]
                                                            }
                                                        </Form.Item>
                                                    }}
                                                </Form.Item>
                                            </>)
                                    }
                                    <Form.Item name='reviewContent'
                                        label={<span className='label'>{t('reviewContent')}</span>}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewContent'),
                                                // validator: async () => {
                                                // if (JSON.stringify(descriptionValue2) === '[{"type":"paragraph","children":[{"text":""}]}]') {
                                                //     // eslint-disable-next-line quotes
                                                //     const helpStr = t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResultExcel')
                                                //     return Promise.reject(new Error(helpStr))
                                                // } else {
                                                //     // 去掉前后空格
                                                //     const editorHtmlValue = editorRef2.current?.serialize({ children: serialize(handleTrim(descriptionValue2)) })
                                                //     // 获取去掉html后的纯文本
                                                //     const word = editorHtmlValue?.replace(/<[^>]*>/g, '')
                                                //     const errorStr = `${t('minLenError')} 10 ${t('lenCharError')}`
                                                //     // 如果已反馈，则不用验证
                                                //     if (feeded) {
                                                //         return Promise.resolve()
                                                //     }
                                                //     if (word) {
                                                //         if (word.length < 10) {
                                                //             return Promise.reject(new Error(errorStr))
                                                //         } else {
                                                //             return Promise.resolve()
                                                //         }
                                                //     } else {
                                                //         return Promise.reject(new Error(errorStr))
                                                //     }
                                                // }
                                                // }
                                            },
                                        ]}
                                    >
                                        {/* <Input hidden /> */}
                                        <Input.TextArea autoSize={{ minRows: 4 }} />
                                        {/* {!feeded ?
                                                : <div dangerouslySetInnerHTML={{
                                                    __html: formObjFeed?.reviewContent ? JSON.parse(formObjFeed?.reviewContent).str : ''
                                                }} style={{ wordBreak: 'break-word' }}></div>
                                            } */}
                                        {/* <DslateConfigProvider
                                            value={{
                                                ...defaultConfig,
                                                plugins: [
                                                    ...Object.values({
                                                        ...plugs
                                                    }), 
                                                ],
                                            }}
                                        >
                                            <DSlate ref={editorRef2} key={editorKey} value={descriptionValue2} onChange={setDescriptionValue2} />
                                        </DslateConfigProvider> */}
                                    </Form.Item>
                                </>}
                                {/* 提交 */}
                                {/* judgesType 1 参与评审 2 旁听 */}
                                {judgesType !== EJudgesType.NULL ? (<Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                                    <Space size={20}>
                                        <Button type="primary" htmlType="submit" loading={loading}
                                            disabled={formObj?.openRelevant !== null && (
                                                // 如果当前是 PL TMT评审类型，TMT评否以后，打回PL TMT，这时，PL TMT又需要再次评审
                                                // isPlReview 为 null 表示前两种类型，true表示PL TMT评审阶段
                                                (feeded && formObj?.isPlReview === null)
                                            )}
                                        >{t('submit')}</Button>
                                    </Space>
                                </Form.Item>) : (
                                    <Form.Item {...tailLayout} style={{ textAlign: 'center', color: 'red' }}>
                                        {t('Vwqf3MpqRk8ApTIjwdErZ')}
                                    </Form.Item>)
                                }
                                {/* <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                                    <Space size={20}>
                                        <Button type="primary" htmlType="submit" loading={loading}
                                        >{t('submit')}</Button>
                                    </Space>
                                </Form.Item> */}
                            </Form>
                        </Col>
                        <Col span={11}>
                            {/* 提案信息 */}
                            <Card title={t('viewInfo')} className='ti_an_detail'>
                                {loaded ?
                                    <Form {...layout} size='small' ref={formRef2}>
                                        <Form.Item name='workGroupId'
                                            label={<span className='label'>{t('Work Group')}</span>}
                                        >
                                            {workgroupList.find(workgroup => workgroup.id === formObj?.workGroupId)?.groupName}
                                        </Form.Item>
                                        <Form.Item name='proposalName'
                                            label={<span className='label'>{t('proposalName')}</span>}
                                        >
                                            {formObj?.proposalName}
                                        </Form.Item>
                                        {/* <Form.Item name='reviewDate'
                                            label={<span className='label'>{t('reviewDate')}</span>}
                                        >
                                            {formObj?.reviewDate?.format('YYYY-MM-DD') + ' ' + (formObj?.reviewDateHours ? formObj?.reviewDateHours : '') }
                                        </Form.Item> */}
                                        {/* 相关BU、责任主体 */}
                                        {formObj?.reviewType !== 3 && formObj?.reviewType !== 4 && (
                                            <>
                                                <Form.Item name='costBuss'
                                                    label={<span className='label'>{t('developCostAttribute')}</span>}
                                                >
                                                    {formObj?.costBuss?.join(', ')}
                                                </Form.Item>
                                                <Form.Item name='dutyBuss'
                                                    label={<span className='label'>{t('developDutySubject')}</span>}
                                                >
                                                    {formObj?.dutyBuss?.join(', ')}
                                                </Form.Item>
                                            </>
                                        )}
                                        {(formObj?.reviewType === 4 || (formObj?.reviewType === 3 && formObj?.isPlReview)) && <>
                                            <Form.Item name='parentTech'
                                                label={<span className='label'>{t('higherLevelTechnicalPoints')}</span>}
                                            >
                                                {formObj?.parentTech}
                                            </Form.Item>
                                            <Form.Item name='productFunction'
                                                label={<span className='label'>{t('productFeatures')}</span>}
                                            >
                                                {formObj?.productFunction}
                                            </Form.Item>
                                            <Form.Item name='techScope'
                                                label={<span className='label'>{t('technicalApplicationRange')}</span>}
                                            >
                                                {formObj?.techScope}
                                            </Form.Item>
                                            <Form.Item name='techPerformance'
                                                label={<span className='label'>{t('technicalPerformanceIndicators')}</span>}
                                            >
                                                {formObj?.techPerformance}
                                            </Form.Item>
                                            <Form.Item name='techSource'
                                                label={<span className='label'>{t('technicalOrigin')}</span>}
                                            >
                                                {formObj?.techSource}
                                            </Form.Item>
                                            <Form.Item name='firstUseDate'
                                                label={<span className='label'>{t('estimatedFirstApplicationTime')}</span>}
                                            >
                                                {formObj?.firstUseDate}
                                            </Form.Item>
                                            <Form.Item name='costBuss'
                                                label={<span className='label'>{t('proposalAttributionBusinessModule')}</span>}
                                            >
                                                {formObj?.costBuss?.join(', ')}
                                            </Form.Item>
                                        </>}
                                        {/* 技术领先性 */}
                                        {(formObj?.reviewType !== 1) && <>
                                            <Form.Item name='technologyLeadership'
                                                label={<span className='label'>{t('technologicalLeadership')}</span>}
                                            >
                                                {findLabel(technologicalLeadershipArr.current, formObj?.technologyLeadership ?? -1)}
                                            </Form.Item>
                                            <Form.Item name='technologyContribution'
                                                label={<span className='label'>{t('technicalContribution')}</span>}
                                            >
                                                {findLabel(technicalContributionArr.current, formObj?.technologyContribution ?? -1)}
                                            </Form.Item>
                                            <Form.Item name='coreTechnology'
                                                label={<span className='label'>{t('techType')}</span>}
                                            >
                                                {labelArr[formObj?.coreTechnology ?? -1]}
                                            </Form.Item>
                                        </>}
                                        {/* 技术成果交付时才显示三个类型的人员 */}
                                        {formObj?.reviewType === 3 && (<>
                                            <Form.Item
                                                name='techLeaders'
                                                label={<span className='label'>{t('techLeaders')}</span>}
                                            >
                                                {formObj?.techLeaders}
                                            </Form.Item>
                                            <Form.Item
                                                name='coreMembers'
                                                label={<span className='label'>{t('coreMembers')}</span>}
                                            >
                                                {formObj?.coreMembers}
                                            </Form.Item>
                                            <Form.Item
                                                name='generalMembers'
                                                label={<span className='label'>{t('generalMembers')}</span>}
                                            >
                                                {formObj?.generalMembers}
                                            </Form.Item>
                                        </>)}
                                        {formObj?.reviewType === 1 && (
                                            <>
                                                <Form.Item name='isDisruptive'
                                                    label={<span className='label'>{t('isDisruptive')}</span>}
                                                >
                                                    {formObj?.isDisruptive ? t('Yes') : t('No')}
                                                </Form.Item>
                                                {formObj?.isDisruptive && <Form.Item name='disruptiveReview'
                                                    label={<span className='label'>{t('reviewResult')}</span>}
                                                >
                                                    {formObj?.reviewResult == null ? 'NA' : (formObj?.disruptiveReview !== null ? (formObj?.disruptiveReview ? t('Yes') : t('No')) : '')}
                                                </Form.Item>}
                                                <Form.Item name='isCross'
                                                    label={<span className='label'>{t('isCross')}</span>}
                                                >
                                                    {formObj?.isCross ? t('Yes') : t('No')}
                                                </Form.Item>
                                                {formObj?.isCross && <Form.Item name='isCrossReview'
                                                    label={<span className='label'>{t('reviewResult')}</span>}
                                                >
                                                    {formObj?.reviewResult == null ? 'NA' : (formObj?.isCrossReview !== null ? (formObj?.isCrossReview ? t('Yes') : t('No')) : '')}
                                                </Form.Item>}
                                            </>
                                        )}
                                        <Form.Item name='description'
                                            label={<span className='label'>{(formObj?.reviewType ? approvalType[formObj.reviewType - 1].label : '')
                                                + (i18n.language !== 'zh' ? ' ' : '') + t('description')}</span>}
                                        >
                                            <div dangerouslySetInnerHTML={{
                                                __html: formObj?.description ? JSON.parse(formObj?.description).str : ''
                                            }} style={{ wordBreak: 'break-word' }}></div>
                                        </Form.Item>
                                        <Form.Item name='files'
                                            label={<span className='label'>{t('attach')}</span>}
                                        >
                                            {formObj?.files
                                                ? <List
                                                    itemLayout="horizontal"
                                                    dataSource={formObj?.files}
                                                    renderItem={item => (
                                                        <List.Item className='attach_ls'
                                                            actions={[
                                                                // <Text className='txt_blue hand' title={t('previewFile')} onClick={async () => {
                                                                //     autoClick(`${UploadAPI}/onlinePreview?filePath=${item?.filePath}`)
                                                                // }}><FileSearchOutlined style={{ fontSize: 16 }} /></Text>
                                                            ]}
                                                        >
                                                            <Skeleton avatar title={false} loading={false} active>
                                                                <List.Item.Meta
                                                                    title={<span className='word txt_blue hand'
                                                                        title={item.fileName}
                                                                        onClick={async () => {
                                                                            showLoading(<Spin size='large' />)
                                                                            const res = await getFile(item.id).finally(() => {
                                                                                hideLoading()
                                                                            })
                                                                            downloadFile(res, item.fileName)
                                                                        }}
                                                                    >{item.fileName}<DownloadOutlined className='icon' /></span>}
                                                                />
                                                            </Skeleton>
                                                        </List.Item>
                                                    )}
                                                />
                                                : '无'
                                            }
                                        </Form.Item>
                                    </Form>
                                    : (
                                        <div
                                            style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                        ><Spin size="large" /></div>
                                    )
                                }
                            </Card>
                        </Col>
                    </Row>
                </Panel>
                {/*
                    PL TMT 重新反馈
                    (PL TMT 评审通过， TMT 评审后未通过，打回给 PL TMT再次评审，
                    此时需要显示出所有 TMT 评审的记录)
                */}
                <Panel
                    header={(!locationSearch.current.isWrite
                        ? t('ITMT')
                        : t('TMT')) + (i18n.language !== 'zh' ? ' ' : '') + t('userList')
                    }
                    key="2"
                >
                    <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
                        <Table className='index_ls' bordered
                            scroll={{ x: 'max-content' }}
                            rowKey='id'
                            dataSource={feedbackTMTList}
                            columns={tmtColumns.filter(v => {
                                if (v.key == 'need') {
                                    return (formObj?.reviewType === 1 && formObj?.isDisruptive)
                                } else if (v.key == 'isCross') {
                                    return (formObj?.reviewType === 1 && formObj?.isCross)
                                } else if (v.key === 'workGroup' || v.key === 'isParticipate') {
                                    // 技术成果交付（来自PL TMT评审的还是保持原状）
                                    return formObj?.reviewType !== 4
                                } else if (v.key === 'technologyLeadership' || v.key === 'technologyContribution' || v.key === 'coreTechnology') {
                                    return formObj?.reviewType !== 1
                                } else {
                                    return true
                                }
                            })}
                            pagination={false}
                        />
                    </ConfigProvider>
                </Panel>

                {/* 已反馈列表 */}
                {/* { formObj?.openRelevant != null && ( <Panel
                    header={(!locationSearch.current.isWrite
                        ? t('ITMT')
                        : t('TMT') ) + (i18n.language !== 'zh' ? ' ' : '') + t('userList')
                    }
                    key="2"
                >
                    <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
                        <Table bordered
                            key={getUuid(8)}
                            dataSource={feedbackList}
                            columns={columns}
                            rowKey="id"
                            pagination={false}
                        ></Table>
                    </ConfigProvider>
                </Panel>)} */}
            </Collapse>
        </Space>
    )
}
export default ReviewStart
